import { Component, OnInit } from "@angular/core";
import { UserLanguage } from "@app/_enums/userLanguage";
import { UserSettingLink } from "@app/_models/settings/user-settings";
import { User } from "@app/_models/user/user";
import { AuthenticationService } from "@app/_services/authentication.service";
import { PersistenceService } from "@app/_services/persistence.service";
import { UserSettingService } from '@modules/usersetting/usersetting.service';

interface LanguageSelect{
    name: string;
    value: string
}

@Component({
    selector: 'language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss']
})

/**
 * Language selector component dropdown component
 * - Changes local storage language
 * - Sends update to userSettings language
 */
export class LanguageSelectComponent implements OnInit{

    public languages: LanguageSelect[] = [];
    public currentLanguage: string;
    public currentUser: User;

    constructor(
        private persistenceService: PersistenceService,
        private userSettingService: UserSettingService,
        private authService: AuthenticationService
    ){
        this.languages = [
            {
                name: "Suomi",
                value: "fi",
            },
            {
                name: "English",
                value: "en",
            },
            {
                name: "Svenska",
                value: "se"
            }
        ]
        this.currentLanguage = this.persistenceService.getLang(); //Get currentlanguage
    }

    ngOnInit(){
        this.currentUser = this.authService.currentUserValue;
    }

    changeLanguage(selectedLanguage: string) {

        // Change stored language
        this.persistenceService.setLang(selectedLanguage);
        this.currentLanguage = selectedLanguage;


        // modified back to usersettings
         if(this.currentUser) {

            let langSettings: UserSettingLink[] = [{
                userAccountId: this.currentUser.id,
                userSettingId: "userLanguage",
                currentVal: UserLanguage[selectedLanguage]
            }];

            this.userSettingService.setUserSettings(langSettings).subscribe();
         }
    }
}